<template>
  <v-dialog
    v-model="show"
    width="70%"
    overlay-color="darktext"
    overlay-opacity="0.6"
    content-class="content-create-template-dialog"
    :persistent="true"
    data-testid="dialog"
    scrollable
    ref="dialog"
  >
    <v-card elevation="0" class="pa-5" v-if="role == 'space_admin' && !loading">
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-card-title class="white pa-0 justify-center d-block">
        <v-row no-gutters>
          <v-col cols="12" md="2">
            <v-btn
              ref="back"
              text
              data-testid="back-button"
              class="rounded-xxl text-none pa-4"
              :ripple="false"
              style="z-index: 1"
              color="greytext"
              @click="redirectToMySpaces"
            >
              <v-icon class="ml-n1">mdi-chevron-left</v-icon
              >{{ $t("spacePageTitle") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="8" v-if="!mobile()">
            <p class="text-h4 font-weight-bold text-center no-break mt-8">
              {{ $t("downgradeFreePlanTitle") }}
            </p>
          </v-col>
          <v-col cols="12" md="8" v-else>
            <p
              class="
                text-body-1
                font-weight-bold
                text-center
                no-break
                mt-8
                mb-n2
              "
            >
              {{ $t("downgradeFreePlanTitle") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" offset-md="2" v-if="!mobile()">
            <p class="text-body-1 text-center no-break greytext--text">
              {{ $t("downgradeFreePlanText") }}
            </p>
          </v-col>
          <v-col cols="12" md="8" offset-md="2" v-else>
            <p class="text-body-2 text-center no-break greytext--text">
              {{ $t("downgradeFreePlanText") }}
            </p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 70vh" ref="content" class="pa-0">
        <v-row no-gutters class="fill-height" align="center" justify="center">
          <v-col
            cols="12"
            md="8"
            class="d-flex flex-column justify-center align-center"
          >
            <v-card width="100%" max-width="600px" rounded="xxl" class="mx-auto">
              <v-card-text class="pa-6 darktext--text">
                <v-row>
                  <v-col cols="12">
                    <p class="d-inline-block float-right">
                      <v-chip
                        class="d-flex text-h6 text-uppercase"
                        label
                        color="anchor20opacity"
                        text-color="accent"
                        >{{ $t("popular") }}</v-chip
                      >
                    </p>
                    <p class="text-h3 font-weight-bold d-inline-block mr-3">
                      Pro
                    </p>
                    <p class="d-inline-block mr-3">
                      <span class="text-h4 d-flex accent--text"> €68 </span>
                      <span class="text-body-1 d-flex greytext--text">
                        €78 {{ $t("whenBilledMonthly") }}
                      </span>
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h4">3</span>
                    <span class="d-block text-body-1 greytext--text">{{
                      $t("downgradeFreePlanBoosters")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h4">250</span>
                    <span class="d-block text-body-1 greytext--text">{{
                      $t("downgradeFreePlanSpaceMembers")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="4" align="center">
                    <span class="d-block text-h4">10GB</span>
                    <span class="d-block text-body-1 greytext--text">{{
                      $t("downgradeFreePlanStorage")
                    }}</span>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions
                class="pa-0 justify-center upgrade-card-action"
                data-testid="upgrade-to-pro-action"
                @click.stop="
                  (upgradeToPlan = 'Pro'),
                    (dialogVisibleUpgradePlan = true),
                    (confirmationDialogTitle = $t(
                      'confirmationDialogTitleUpgradeToPlan' + upgradeToPlan
                    ))
                "
                :style="{ cursor: 'pointer' }"
              >
                <span class="text-h6">{{ $t("continuePro") }}</span>
              </v-card-actions>
            </v-card>
            <p class="my-5">{{ $t("or") }}</p>
            <v-btn
              data-testid="free-plan-button"
              class="rounded-xxl text-none greytext--text mb-5"
              color="white"
              @click.stop="
                (dialogVisible = true),
                  (confirmationDialogTitle = $t(
                    'confirmationDialogTitleDowngradeFreePlan'
                  )),
                  (confirmationDialogText = $t(
                    'confirmationDialogTextDowngradeFreePlan'
                  )),
                  (confirmationDialogSubmitBtn = $t('confirm'));
                confirmationDialogCancelBtn = $t('cancel');
              "
            >
              {{ $t("downgradeFree") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card elevation="0" class="pa-5" v-if="role != 'space_admin' && !loading">
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-card-title class="white pa-0 justify-center">
        <v-row no-gutters>
          <v-col cols="12" md="2">
            <v-btn
              ref="back"
              text
              data-testid="back-button"
              class="rounded-xxl text-none pa-4"
              :ripple="false"
              style="z-index: 1"
              color="greytext"
              @click="redirectToMySpaces"
            >
              <v-icon class="ml-n1">mdi-chevron-left</v-icon
              >{{ $t("spacePageTitle") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="8">
            <p class="text-h4 font-weight-bold text-center no-break mt-8">
              {{ $t("downgradeFreePlanTitle2") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" offset-md="2">
            <p class="text-h6 text-center no-break">
              {{ $t("downgradeFreePlanText2") }}
            </p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="height: 70vh" ref="content" class="pa-0">
        <v-row no-gutters class="fill-height" align="center" justify="center">
          <v-col
            cols="12"
            md="8"
            class="d-flex flex-column justify-center align-center"
          >
            <v-icon size="220"> mdi-lock-outline </v-icon>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ConfirmationDialog
      v-if="dialogVisible"
      ref="confirmationDialog"
      :visible="dialogVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-free-plan"
      @close="dialogVisible = false"
      @proceedSubmit="downgrade()"
    />
    <ConfirmationDialogUpgradePlan
      v-if="dialogVisibleUpgradePlan"
      ref="confirmationDialogUpgradePlan"
      :visible="dialogVisibleUpgradePlan"
      :cd-title="confirmationDialogTitle"
      :plan="upgradeToPlan"
      data-testid="confirmation-dialog-upgrade-plan"
      @close="dialogVisibleUpgradePlan = false"
      @proceedError="showErrorMessageUpgradePlan"
    />
  </v-dialog>
</template>
<script>
import i18n from "./../plugins/i18n";
import AlertMessages from "./AlertMessages";
import ConfirmationDialog from "./ConfirmationDialog";
import { downgradeToFreePlan } from "./../api/spaceApi";
import { repeatedMethodsMixin } from "../mixins/repeatedMethodsMixin";
import { eventBus } from "../eventbus";
import ConfirmationDialogUpgradePlan from "./ConfirmationDialogUpgradePlan.vue";

export default {
  components: {
    AlertMessages,
    ConfirmationDialog,
    ConfirmationDialogUpgradePlan
  },
  props: {
    //visible: Boolean
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: "",
      alertType: "",
      alertValue: false,
      spaceId: window.$cookies.get("space_id"),
      space: window.location.host.split(".")[0],
      loading: false,
      role: localStorage.space ? JSON.parse(localStorage.space).role : null,
      dialogVisible: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogSubmitBtn: "",
      confirmationDialogCancelBtn: "",
      dialogVisibleUpgradePlan: false,
      upgradeToPlan: "",
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    visible() {
      return this.$store.state.lock;
    },
  },
  watch: {
    visible() {
      this.loading = true;
      this.role = JSON.parse(localStorage.space).role;
      this.loading = false;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    showErrorMessageUpgradePlan() {
      this.dialogVisibleUpgradePlan = false;
      this.alertType = "error";
      this.alertMsg = i18n.t("serverError");
      this.alertValue = true;
    },
    async downgrade() {
      //api call
      //redirect to dashboard
      //show success message
      try {
        const response = await downgradeToFreePlan(this.spaceId);
        if (response.status == 200) {
          this.$store.dispatch("getSubscribedPlan", response.data.data);
          this.$store.dispatch("unlockPlatform");

          eventBus.$emit("changeLogo", "downgradePlan");

          this.$router.push({
            name: "Dashboard",
            params: { successfullyDowngradedToFreePlan: true },
          });
        }
      } catch (e) {
        if (e.response) {
          this.dialogVisible = false;
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    redirectToMySpaces() {
      window.location.href =
        process.env.VUE_APP_PROTOCOL +
        "://id." +
        process.env.VUE_APP_DOMAIN +
        "/spaces";
    },
  },
};
</script>
